import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Breadcrums.css';

const Breadcrums = ({ product }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3 px-4 sm:px-6 lg:px-12 py-4">
      {/* Back button */}
      <button
        onClick={() => navigate(-1)}
        className="group flex items-center gap-2 px-4 py-2 rounded-xl border-2 border-[var(--brand-primary-200)] bg-white
                   hover:border-[var(--brand-primary-500)] hover:bg-[var(--brand-primary-600)] hover:shadow-lg
                   transition-all duration-300"
      >
        <svg
          className="w-4 h-4 text-[var(--brand-primary-600)] group-hover:text-white transition-colors duration-300 group-hover:-translate-x-0.5 transform"
          fill="none" stroke="currentColor" strokeWidth="2.5"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
        <span className="text-xs font-bold text-[var(--brand-primary-600)] group-hover:text-white transition-colors duration-300 uppercase tracking-wide">
          Back
        </span>
      </button>

      {/* Breadcrumb trail */}
      <div className="flex items-center gap-1.5 text-xs text-gray-400 overflow-hidden">
        <span className="hover:text-[var(--brand-primary-500)] cursor-pointer transition-colors" onClick={() => navigate('/')}>Home</span>
        <svg className="w-3 h-3 text-gray-300 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
        <span className="hover:text-[var(--brand-primary-500)] cursor-pointer transition-colors capitalize" onClick={() => navigate(-1)}>
          {product.category}
        </span>
        <svg className="w-3 h-3 text-gray-300 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
        <span className="text-[var(--brand-primary-700)] font-semibold truncate max-w-[180px] sm:max-w-xs">
          {product.name}
        </span>
      </div>
    </div>
  );
};

export default Breadcrums;
